import {Prop, Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {OrderItem, Product} from '../../../Models';
import {CustomerDataDTO} from '../../../DTOs';
import Modal from '../../Modal/Modal.vue';
import PublicTransportItem from '../PublicTransportItem/PublicTransportItem.vue';
import {VuexObjectMixin} from '../../../Mixins';
import PublicTransportTicket from '../../Icons/PublicTransportTicket.vue';
import {mapGetters} from 'vuex';
import {AdditionalOrderItemConfiguration} from '../../../Models/AdditionalOrderItemConfiguration';
import {PublicTransportConfig} from '../../../Models/PublicTransportConfig';

@Component({
  components: {
    Modal,
    PublicTransportItem,
    PublicTransportTicket,
  },
  computed: {
    ...mapGetters({
      currentBuyerData: 'getBuyerData',
      products: 'getProducts',
    }),
  },
})
export default class OrderPublicTransportModal extends VuexObjectMixin {
  @Prop({type: String, required: true}) modalTriggerText: string | undefined;

  currentBuyerData: CustomerDataDTO | undefined;

  private loading: boolean = false;
  private additionalOrderItemConfigs: Array<AdditionalOrderItemConfiguration> = [];

  mounted() {
    if (this.cart?.order) {
      this.additionalOrderItemConfigs = this.cart.order.additionalOrderItemConfigurations;
    }
  }
  @Watch('cart.order.additionalOrderItemConfigurations')
  onOuterAoicChange() {
    if (this.cart?.order) {
      this.additionalOrderItemConfigs = this.cart.order.additionalOrderItemConfigurations;
    }
  }

  getPublicTransportName(item: OrderItem | Product): string {
    return item.registrationRequired === 'Ja' ? this.buyerName : '';
  }

  get buyerName(): string {
    return this.currentBuyerData!.firstName + ' ' + this.currentBuyerData!.lastName;
  }

  get isSingleMode() {
    //return this.pubTransConfigs.length === 1;
    return 1;
  }

  get orderItemsWithProductsIncludingPubTrans(): Array<OrderItem> {
    if (this.productsWithPubTransIncluded) {
      const productIdsWithPubTrans = this.productsWithPubTransIncluded.map(p => p.id);
      return this.currentOrder!.orderItems.filter(oi => {
        const prodIdx = productIdsWithPubTrans.indexOf(oi.productId);
        return prodIdx >= 0;
      });
    }
    return [];
  }

  get productsWithPubTransIncluded(): Array<Product> {
    return this.products.filter(p => p.localPubTransIncluded);
  }

  get hasSelectedConfigsForPubTrans(): boolean {
    //return this.pubTransConfigs.filter(c => c.usePubTrans).length > 0;
    return true;
  }

  get isValid(): boolean {
    let invalidPubTransConfigs: Array<AdditionalOrderItemConfiguration> = [];
    this.additionalOrderItemConfigs.forEach((aoic) => {
      const ptc = aoic.publicTransportConfig;
      if (ptc instanceof PublicTransportConfig) {
        if (ptc.usePubTrans &&
          (!ptc.passengerName || !ptc.passengerSurname
            || ptc.passengerName === '' || ptc.passengerSurname === ''
            || !ptc.selectedDate
          )) {
          invalidPubTransConfigs.push(aoic);
        }
      }
    });

    return invalidPubTransConfigs.length === 0;
  }

  hasNameAndSurname(name: string): boolean {
    return name.trim().split(' ').length > 1;
  }

  updateAdditionalOrderItemConfig(additionalOrderItemConfig) {
    this.$emit('updateAdditionalOrderItemConfig', additionalOrderItemConfig);
    if (this.cart?.order) {
      this.additionalOrderItemConfigs = [];
      this.additionalOrderItemConfigs = this.cart.order.additionalOrderItemConfigurations;
    }
  }
}
